module.exports = "<form>\r\n  <spk-card title=\"Search Application Settings\">\r\n    <spk-search-grid #grid defaultSortProperty=\"Name ASC\" list=\"ApplicationSettingSearchRow\" [leftLinks]=\"leftLinks\"></spk-search-grid>\r\n  </spk-card>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/application-settings/application-settings/application-settings.component.html
// module id = ./src/app/components/framework/application-settings/application-settings/application-settings.component.html
// module chunks = main